// Brand-color helpers for CTAs drawn on white surfaces (dialogs, cards).

const FALLBACK_BRAND = '#004990';

// Relative luminance (WCAG) of a #rgb / #rrggbb color, or null if unparseable.
export const luminance = (hex) => {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-f]{6}$/i.test(h)) return null;
  const [r, g, b] = [0, 2, 4].map((i) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// A fleet brand color usable as a button background on a white surface, plus a
// readable text color for it. Near-white (or unparseable) brand colors fall back
// to navy: a fleet whose menu background is #FFFFFF otherwise renders a white
// button with white text — invisible.
export const ctaColors = (brandColor) => {
  const lum = luminance(brandColor);
  const background = lum === null || lum > 0.85 ? FALLBACK_BRAND : brandColor.trim();
  const text = luminance(background) > 0.45 ? '#1a1a1a' : '#fff';
  return { background, text };
};
